import React, { useState, useEffect } from 'react'
import { Button, Table, Container, Row, Col, Form, Modal } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import { fetchAllGroups, IGroup } from '../../../utils/api/products'
import { IPriceList } from '../../../utils/api/customers'

interface PriceListSectionProps {
  customer: any
  setCustomer: React.Dispatch<React.SetStateAction<any>>
  user: any
}

export const PriceListSection: React.FC<PriceListSectionProps> = ({
  customer,
  setCustomer,
  user
}) => {
  const [showModal, setShowModal] = useState(false)
  const [groups, setGroups] = useState<IGroup[]>([])
  const [selectedGroup, setSelectedGroup] = useState<IGroup[]>([])
  const [sellPrice, setSellPrice] = useState("")

  useEffect(() => {
    fetchAllGroups().then(setGroups)
  }, [])

  const toogleModal = () => setShowModal(!showModal)

  const addToItem = (item: IPriceList) => {
    setCustomer({
      ...customer,
      priceList: [...customer.priceList, item]
    })
  }

  const removeItem = (item: IPriceList) => {
    setCustomer({
      ...customer,
      priceList: customer.priceList.filter((i: IPriceList) => i !== item)
    })
  }

  const close = () => {
    setSelectedGroup([])
    setSellPrice("")
    toogleModal()
  }

  const addOrderItem = (e: React.FormEvent<Element>) => {
    e.preventDefault();
    e.stopPropagation();
    const item = {
      groupId: selectedGroup[0].id,
      groupName: selectedGroup[0].name,
      price: Number(sellPrice)
    }
    addToItem(item)
    close()
  }

  if (!user || user.role === 'vendedor') return null

  return (
    <>
      <h5 className="mt-4">Lista de precios</h5>
      <Table bordered size="sm">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Precio</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {customer.priceList?.map((item: IPriceList, index: number) => (
            <tr key={index}>
              <td>{item.groupName}</td>
              <td>{item.price}</td>
              <td>
                <div className="d-grid">
                  <Button size="sm" variant="outline-danger" onClick={() => removeItem(item)}>X</Button>
                </div>
              </td>
            </tr>
          ))}
          <tr>
            <td>
              <div className="d-grid">
                <Button size="sm" variant="outline-primary" onClick={toogleModal}>Agregar producto</Button>
              </div>
            </td>
            <td colSpan={2}></td>
          </tr>
        </tbody>
      </Table>

      <Modal show={showModal} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Producto</Modal.Title>
        </Modal.Header>
        <Form onSubmit={addOrderItem}>
          <Modal.Body>
            <Container>
              <Row className="mb-2">
                <Col>
                  <Form.Group controlId="product">
                    <Form.Label>Producto</Form.Label>
                    <Typeahead
                      id="group-selection"
                      labelKey="name"
                      onChange={setSelectedGroup}
                      options={groups}
                      placeholder="Seleccionar producto..."
                      selected={selectedGroup}
                      inputProps={{ required: true }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-2">
                <Col>
                  <Form.Group controlId="unitPrice">
                    <Form.Label>Precio unitario</Form.Label>
                    <Form.Control type="number" placeholder="Precio unitario" value={sellPrice} onChange={(e) => setSellPrice(e.target.value)} required />
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={close}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Agregar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}